import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {appInfo.title}
              </h2>
              <p className="mt-3 text-sm text-foreground-700 font-medium">
                {appInfo.subtitle}
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
                {appInfo.desc}
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-6 py-3 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-all hover:bg-foreground-800">
                  <i className="ri-smartphone-line mr-2"></i>
                  手机端打开
                </button>
                <button className="w-full sm:w-auto px-6 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:border-foreground-400 transition-colors">
                  <i className="ri-computer-line mr-2"></i>
                  电脑端观看
                </button>
              </div>
            </div>
            <div className="flex-shrink-0 w-56 md:w-64">
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src={appInfo.image}
                  alt={appInfo.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}